import React, { memo } from 'react'

import { Button, FlexBox } from '@surglogs-app/ui'

import { useTranslation } from './services'

interface SignaturePadDialogButtonsProps {
  onConfirmClick: () => void
  onClearClick: () => void
  onCancelClick: () => void
  disabled: boolean
}

export const SignaturePadDialogButtons = memo(
  ({
    onConfirmClick,
    onClearClick,
    onCancelClick,
    disabled,
  }: SignaturePadDialogButtonsProps) => {
    const { t } = useTranslation()

    return (
      <FlexBox {...{ gap: 'sm', mt: 'md' }}>
        <Button
          {...{
            onClick: onConfirmClick,
            disabled,
            'aria-label': 'add-signature-pad-confirm-button',
            variant: 'success',
          }}>
          {t('confirm')}
        </Button>
        <Button {...{ onClick: onClearClick, variant: 'secondary' }}>
          {t('clear')}
        </Button>
        <Button {...{ onClick: onCancelClick, variant: 'secondary' }}>
          {t('cancel')}
        </Button>
      </FlexBox>
    )
  },
)
